export default [
  {
    path: "/spi/mahasiswa",
    name: "spi-mahasiswa",
    component: () => import("../../views/rektorat/spi/RekapMahasiswa.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "SPI", url: "/submenu/spi" },
        { title: "Mahasiswa", active: true },
      ],
      pageTitle: "Mahasiswa",
    },
  },
];
